import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import OrderHeroImg from '../../assets/images/ordering/order-hero.png';
import { MultiStepFormController, MultiStepFormView, } from '../../components/MultiStepPage/MultiStepPage';
import { FormController } from './Form/FormController';
import { OrderAcknowledge } from './Form/OrderAcknowledge/OrderAcknowledge';
import { OrderConfirm } from './Form/OrderConfirm/OrderConfirm';
import { OrderReview } from './Form/OrderReview/OrderReview';
import { pageStyle } from './styles';
const nextStepText = ['BTN.CONTINUE', 'BTN.CONFIRM_ORDER', 'BTN.SUBMIT'];
const initialNextStepLocked = false;
export const OrderingPage = () => {
    const [disclaimerChecked, setDisclaimerChecked] = useState(false);
    const [purchaseAgreementChecked, setPurchaseAgreementChecked] = useState(false);
    const [termsAgreementChecked, setTermsAgreementChecked] = useState(false);
    const { t: translate } = useTranslation('translation', { keyPrefix: 'ORDER' });
    const navigate = useNavigate();
    const { nextTxt, prevTxt } = useMemo(() => ({
        // Translate button text
        nextTxt: nextStepText.map((txt) => translate(txt)),
        prevTxt: translate('BTN.CANCEL'),
    }), []);
    useEffect(() => {
        window.scrollTo(0, 0); // reset scroll position to top
    }, []);
    const goBack = () => navigate(-1);
    const goNext = (currentStep, handleNext) => {
        if (currentStep === 2) {
            navigate('/onboarding');
        }
        else {
            handleNext();
        }
    };
    return (_jsxs(Box, { sx: pageStyle, children: [_jsx(Box, { className: 'formWrapper', children: _jsxs(MultiStepFormController, { initialNextStepLocked: initialNextStepLocked, children: [_jsxs(MultiStepFormView, { children: [_jsx(OrderReview, {}), _jsx(OrderConfirm, { disclaimerChecked: disclaimerChecked, setDisclaimerChecked: setDisclaimerChecked }), _jsx(OrderAcknowledge, { purchaseAgreementChecked: purchaseAgreementChecked, termsAgreementChecked: termsAgreementChecked, setPurchaseAgreementChecked: setPurchaseAgreementChecked, setTermsAgreementChecked: setTermsAgreementChecked })] }), _jsx(FormController, { className: 'buttonWrapper', onPrev: goBack, onNext: goNext, nextStepText: nextTxt, prevStepText: prevTxt })] }) }), _jsxs(Box, { className: 'heroWrapper', children: [_jsx("img", { src: OrderHeroImg, alt: '' }), _jsxs(Typography, { variant: 'h2', sx: { fontSize: '1.75rem' }, children: [_jsx("span", { className: 'light', children: translate('HERO.TITLE.PART1') }), _jsx("span", { children: translate('HERO.TITLE.PART2') })] }), _jsx(Typography, { variant: 'subtitle1', children: translate('HERO.SUBTITLE') })] })] }));
};
